export class StringFunctions {

    static truncate(string, maxLength) {
        if (string.length > 20)
            return string.substring(0, maxLength || 15) + '...' + string.substring(string.length - 7, string.length);
        else
            return string;
    };

    static shorten(string, oldLength, newLength) {
        if (string.length > oldLength)
            return string.substring(0, newLength) + '...';
        else
            return string;
    };
    static getProductArea = (cat) => {
        switch (cat) {
            case 'IP' : return 'Intellectual Property (IP)';
            case 'HR' : return 'Human Resources (HR)';
            case 'BA' : return 'Business Administration';
            case 'FUND' : return 'Funding & Investment';
            case 'SALES' : return 'Sales & Supply';
            case 'PROPERTY' : return 'Property';
            case 'IDENTITY' : return 'Identity';
            case 'DATA' : return 'Data Protection';
            case 'CORPORATE' : return 'Company & Corporate';
            case 'EU' : return 'EU Compliance';
            case 'RISK' : return 'Risk & Compliance';
            case 'B2B' : return 'Dispute Resolution';
            default: break;
        }
        return cat;
    }
}